import React, { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';
import _ from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ReactPlayer from 'react-player';

// constants
import LocalStrings from '../../assets/languages';
import appIcons from '../../constants/appIcons';

// files
import fileDocumentIcon from '../../assets/img/icons/file_document.svg';
import NoImgIcon from '../../assets/img/placeholders/NoImg.svg';
import { CDN_URL } from '../../constants/constant';

const RENDERFILE_INITIAL_VALUE = {
  state: false,
  file: null,
  filename: '',
  type: 'image',
  ext: 'jpg'
};

const AllFilesDropOnly = props => {
  const { className, insideText, accept, maxSize = null } = props;

  const [renderFile, setRenderFile] = useState(RENDERFILE_INITIAL_VALUE);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    return () => {
      setRenderFile(RENDERFILE_INITIAL_VALUE);
    };
  }, []);

  const onDropFile = files => {
    let file = files[0];

    setErrorMessage('');
    let reader = new FileReader();
    reader.onloadend = () => {
      const item = reader.result;

      const data = { file: item, filename: file.name.replace(/ /g, '-') };
      const ext = file.name.split('.').pop();

      // --- Sends processed data to parent
      props.onFileSave(data);
      props.onFileChangeLocally(true);

      // --- Renders the image instead of DropZone
      let local_renderFile = _.cloneDeep(RENDERFILE_INITIAL_VALUE);
      local_renderFile.state = true;
      local_renderFile.file = item;
      local_renderFile.filename = data.filename;
      local_renderFile.ext = ext;
      local_renderFile.type = _.includes(['svg', 'png', 'jpg', 'jpeg'], ext)
        ? 'image'
        : _.includes(
            ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'zip', 'tar', 'rar'],
            ext
          )
        ? 'doc'
        : 'video';
      setRenderFile(local_renderFile);
    };
    reader.readAsDataURL(file);
  };

  const onFilesRemove = () => {
    setRenderFile(RENDERFILE_INITIAL_VALUE);
  };

  return (
    <>
      {!renderFile.state ? (
        <>
          <Dropzone
            onDrop={onDropFile}
            accept={accept ? accept : ''}
            multiple={false}
          >
            {({ getRootProps, getInputProps }) => (
              // <section className={`${hideDropZoneClass}`}>
              <div {...getRootProps()} className={`${className}`}>
                <input {...getInputProps()} />

                {!_.isEmpty(errorMessage) ? (
                  <div className="d-flex justify-content-center align-items-center custom-text1-normal-danger">
                    <span>{errorMessage}</span>
                  </div>
                ) : (
                  <>
                    <div
                      className="d-flex justify-content-center align-items-center custom-text1-normal-secondary"
                      style={{ gap: 8 }}
                    >
                      <div
                        className="font-icomoon"
                        style={{ rotate: '180deg', fontSize: '1.25rem' }}
                      >
                        {appIcons.downloadIcon}
                      </div>
                      <span>{insideText}</span>
                    </div>
                  </>
                )}
              </div>
              // </section>
            )}
          </Dropzone>
        </>
      ) : renderFile.type === 'image' ? (
        <>
          {/* <div className={`${className}`}>
            <LazyLoadImage
              alt={'Image'}
              effect="blur"
              placeholder={
                <img
                  src={NoImgIcon}
                  className="custom-media-image"
                  alt="lazy load placeholder on error"
                />
              }
              className="custom-media-image"
              src={renderFile.file}
              onError={e => {
                e.target.onerror = null;
                e.target.src = NoImgIcon;
              }}
            />
          </div> */}
          <div
            className="col-12 padding-left-0 padding-right-0"
            style={{ paddingLeft: 0, paddingRight: 0 }}
          >
            <div className={`uploaded-attachment-displaybox`}>
              <div className="row m-0">
                <div className="col-2 col-sm-2 col-md-1 p-0 text-center">
                  <LazyLoadImage
                    className="image-file"
                    alt={'this the available gallery item'}
                    effect="blur"
                    placeholder={
                      <img
                        src={NoImgIcon}
                        className="image-file"
                        alt="lazy load placeholder on error"
                      />
                    }
                    src={renderFile.file}
                    onError={e => {
                      e.target.onerror = null;
                      e.target.src = NoImgIcon;
                    }}
                  />
                </div>
                <div className="col-6 col-sm-6 col-md-9 p-0 custom-text1-normal-secondary">
                  <div className="file-name">{renderFile?.filename}</div>
                </div>
                <div
                  className="col-4 col-sm-4 col-md-2 d-flex justify-content-end align-items-center"
                  style={{ gap: '0.5rem' }}
                >
                  {/* <a
                    className="action-button"
                    href={`${CDN_URL}${renderFile?.file}`}
                    //  filePreview = `${CDN_URL}${file}`;
                    title="Download"
                    download
                    target="_blank"
                  >
                    <div className="file-icons">{appIcons.downloadIcon}</div>
                  </a> */}

                  {/* <span
                    className="font-icomoon custom-text2-medium-theme cursor-pointer"
                    onClick={onFilesRemove}
                  >
                    {appIcons.trashIcon}
                  </span> */}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : renderFile?.type === 'video' ? (
        <>
          <div className={`${className}`}>
            <ReactPlayer
              className="custom-iframe-with-height"
              controls
              url={renderFile.file}
            />
          </div>
        </>
      ) : (
        <>
          <div className={`${className}`}>
            <div
              className="d-flex w-100 justify-content-center"
              style={{ gap: 8 }}
            >
              {/* --- File icon --- */}
              <img src={fileDocumentIcon} alt={renderFile.filename} />

              {/* --- File name --- */}
              <span>{renderFile.filename}</span>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AllFilesDropOnly;
